import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Grid, Row, Col, Panel, Button, Breadcrumb, ButtonToolbar } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import Spinner from '../../components/Widgets/spinner';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { Toolbar, Data } from 'react-data-grid-addons';
import { SkyLightStateless } from 'react-skylight';
import { convertLocalDate } from '../Common/cleanDates';
import {InputField} from "../Common/inputField"
import { Field } from 'redux-form';

const DateFormatter = React.createClass({
  render() {
    return (this.props.value) ?
      <span>{convertLocalDate(this.props.value, 'MMM DD YYYY')}</span> : null;
  },
});

class AdjustmentLog extends Component {
  constructor() {
    super();
    this.state = {
      rows: [], 
      limit: 0,
    };
  }

  componentDidMount() {
    this.props.grabAdjustmentLogs();
  }

  componentDidUpdate(prevProps) {
    if (this.props.logs && this.props.logs !== prevProps.logs) {
      let rows = [];
      this.props.logs.adjustment_inventory_logs.map((log) => {
        log.new_quantity = log.CurrentQuantity + log.AdjustmentQuantity;
        rows.push(log);
        this.setState({
          rows: rows
        });
      });
    }
  }

  searchLimit = (e) => {
    if (/^\d+$/.test(this.props.limit)) {
      this.props.grabAdjustmentLogs(this.props.limit);
    } else {
      this.props.grabAdjustmentLogs(100);
    }
  }

    renderLimit = () => {
      const {handleSubmit} = this.props;
      return (
        <Row>
          <Col>
            <ButtonToolbar>
              <Button
                onClick={(e) => this.searchLimit(e)}
                type="submit"
                >
              <em className="fa fa-search marginRightStyle" /><Translate value="show_number_of_changes"/>
              </Button>
            </ButtonToolbar>
          <form onSubmit={ handleSubmit(this.searchLimit) }>
            <Field 
              style={{width: 350, marginTop: 10}}
              component={InputField}
              name='limit'
              placeholder='Number of Results...'
            />
          </form>
        </Col>
      </Row>
      )
    }

    handleLimit = (limit) => {
      this.setState({ limit: limit})
    }

    renderTable = () => {
      if (this.props.isLoading && !this.props.error) return <Spinner />;
      else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{this.props.error}</div></ContentWrapper>
      
      const getRows = () => Data.Selectors.getRows(this.state);
  
      const getSize = () =>  getRows().length;
  
      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return Object.assign({ Idx: rowIdx }, rows[rowIdx]);
      };
  
      const handleFilterChange = filter => {
        const newFilters = Object.assign({}, this.state.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        this.setState({ filters: newFilters });
      };
  
      const columns = [
        {
          key: 'ProductName',
          name: <Translate value='product'/>,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 200,
          minColumnWidth: 10
        },
        {
          key: 'ReasonDesc',
          name: <Translate value='reason'/>,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 150,
          minColumnWidth: 10,
        },
        {
          key: 'AdjustmentQuantity',
          name: <Translate value='quantity_change'/>,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          minColumnWidth: 10,
        },
        {
          key: 'CurrentQuantity',
          name: <Translate value='prior_quantity'/>,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          minColumnWidth: 10
        },
        {
          key: 'new_quantity',
          name: <Translate value='new_quantity'/>,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 120,
          minColumnWidth: 10
        },
        {
          key: 'BatchNum',
          name: <Translate value='batch_number'/>,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          minColumnWidth: 10
        },
        {
          key: 'CreateTime',
          name: <Translate value='created'/>,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 120,
          minColumnWidth: 10,
          formatter: DateFormatter,
        },       
      ];

      return (
        <Row>
          <Col sm={12} style={{marginTop: 25}}>
            {/* we need this Math.Random key because RDG is trash --Anthony */}
            <div key={Math.random()} style={{maxWidth: '99%'}} id="ProductConvert-dataGrid1">
              <ReactDataGrid 
                rowkey='id'
                enableCellSelect
                toolbar={<Toolbar enableFilter />}
                columns={columns}
                onAddFilter={handleFilterChange}
                headerRowHeight={60}
                rowHeight={40}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={541}
              />
            </div>
          </Col>
        </Row>
      );
    }

    render() {
      return (
        <Panel style={{marginTop: 30}} header ={<Translate value="change_log"/>} id="category2-detail">
          {this.renderLimit()}
          {this.renderTable()}
        </Panel>         
      )
    }
}

export default AdjustmentLog;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/adjustmentLog.jsx